import { useIntl } from "react-intl";
import { useColumnOrder, useTable } from "react-table";

import DataTable from "components/v2/Table/DataTable";
import type { ScheduleStopValue } from "@RequestFormV2/defaults/scheduleDefaults";
import { useReviewScheduleColumns } from "@RequestFormV2/components/ReviewPage/sections/ReviewSchedule/reviewScheduleColumns";

interface ReviewScheduleStopsTableProps {
  stops: ScheduleStopValue[];
  getTimezoneLabel: (value?: string | null) => string;
}

export default function ReviewScheduleStopsTable({ stops, getTimezoneLabel }: ReviewScheduleStopsTableProps) {
  const intl = useIntl();
  const columns = useReviewScheduleColumns(intl, getTimezoneLabel);
  const tableInstance = useTable({ columns, data: stops }, useColumnOrder);

  return <DataTable tableInstance={tableInstance} tableLayout="fixed" />;
}
